import React from "react";
import "./logoDropDownOption.css";
import { Link } from "react-router-dom";

const LogoDropDownOption = ({ icon, title, pageLink }) => {
  return (
    <Link to={pageLink} className="logoOption">
      <div className="logoOption">
        <div className="logoOption-icon">
          <img src={icon} alt="" />
        </div>
        <div className="logoOption-content">
          <h5>{title}</h5>
        </div>
      </div>
    </Link>
  );
};

export default LogoDropDownOption;
